import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "../styles/footer.css";

export default function Footer() {
    const { authEnabled, user } = useAuth();
    return (
        <footer className="app-footer">
            <div className="footer-inner">
                <div className="footer-brand">
                    <Link to="/" aria-label="Be Accredited Group — home">
                        <img src="/images/be+accredited+group.webp" alt="Be Accredited Group" width="1473" height="304" />
                    </Link>
                    <p>Customer credentials. Kept in one place.</p>
                </div>
                <div className="footer-information">
                    <nav aria-label="Footer navigation">
                        <Link to="/">Credentials</Link>
                        {authEnabled && user && <Link to="/profile">Your account</Link>}
                        <Link to="/data-deletion-request">Request data deletion</Link>
                    </nav>
                    <p>Share the credential’s page link in CRM, never the password.</p>
                </div>
            </div>
            <div className="footer-bottom">
                <span>© {new Date().getFullYear()} Be Accredited Group</span>
                <span>Password Manager</span>
            </div>
        </footer>
    );
}
